<template>
  <div>
    <v-card flat color="white" min-width="400px">
      <v-flex xs12 sm12 md12 lg12>
          <v-card flat color="white">
              <h3 >
              Documents
              <v-btn flat color="primary">
                <v-icon
                  @click="addItem()"
                >add_circle_outline</v-icon>
              </v-btn>
            </h3>
            <v-card-text>
                <v-layout justify-center align-center wrap>
                    <v-flex xs12 mx-2 mb-1 v-for="document in documents" :key="document.id">
                        <v-card flat color="white">
                            <v-layout justify-left align-center wrap>
                                <v-flex xs4>
                                    <h4 class="grey--text font-weight-light">{{formatDate(new Date(document.updatedAt))}}</h4>
                                </v-flex>
                                <v-flex xs6>
                                    <h4 class="grey--text">{{document.name}}</h4>
                                </v-flex>
                                <v-flex xs2>
                                    <v-layout justify-center>
                                        <v-icon @click="viewFile(document)">open_in_new</v-icon>
                                        <v-icon @click="downloadFile(document)">download</v-icon>
                                        <v-icon color="red" @click="deleteItem(document)">delete</v-icon>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card-text>
          </v-card>
            
          </v-flex>

          <v-dialog v-model="uploadFileModal" max-width="750px">
     
      <v-card flat color="white">
         <v-toolbar flat color="primary">
        <h1 class='headline white--text'>ATTACH FILE</h1>
        <v-spacer></v-spacer>
        <v-btn flat color="white" @click="uploadFileModal=false">X</v-btn>
      </v-toolbar>
      <v-flex xs12 px-4 mx-4>
      <v-select v-model="uploadType" label="Upload Type" :items="uploadTypes"></v-select>
      </v-flex>
      <v-flex xs12 px-4 mx-4 v-if="uploadType==='URL'">
      <v-text-field  label="*File Name" v-model="fileName"></v-text-field>
      </v-flex>
      <v-flex xs12 px-4 mx-4 v-if="uploadType!==''">
      <v-text-field  label="File Description" v-model="fileDescription"></v-text-field>
      </v-flex>
      <v-flex xs12 px-4 mx-4 v-if="uploadType==='URL'">
      <v-text-field  label="*File URL" v-model="fileUrl"></v-text-field>
      </v-flex>
      <br/>
        <input v-if="uploadType==='File'" class="file-input" @change="selectFile" ref="file" type="file">
        <v-card-actions>
          <v-layout justify-center>
        <v-btn v-if="file&&uploadType==='File'" round color="primary" @click="uploadFile">Upload</v-btn>
        <v-btn v-if="uploadType==='URL'&&fileName!==''&&fileUrl!==''" round color="primary" @click="saveUrl">Save URL</v-btn>
        </v-layout>
        </v-card-actions>
      </v-card>
      
    </v-dialog>
    
    </v-card>
        
  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
export default {
props:['DocumentUpload','documents','locationid','deviceid','locationnetworkid','locationnodeid','customerid','contactid','applicationid','serviceaccountid', 'customerOrganisationId'],
data() {
    return {
        file:'',
        uploadFileModal:false,
        editFileModal: false,
        fileDescription:'',
        fileUrl:'',
        uploadType:'',
        fileName:'',
        fileUrl:'',
        uploadTypes:["File", "URL"],
        editedItem:{},
        documentHeaders:[
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
      },
        {
          text: "Description",
          align: "center",
          value: "description"
      }
      ]
}},
methods:{
     selectFile(event) {
    this.file = event.srcElement.files[0];
},
viewFile(item){
  console.log(item)
const linkSource = `data:${item.type};base64,${item.base64}`;
// window.open(linkSource, '_blank').focus();
let pdfWindow = window.open("")
pdfWindow.document.write(
    `<iframe width='100%' height='100%' src='${linkSource}'></iframe>`
)
},
downloadFile(item){
//   Api()
//   .get('/upload/'+id)
//   .then(response=>{
  
      let file = Buffer.from(item.base64, 'base64')
      const linkSource = `data:${item.type};base64,${item.base64}`;
    const downloadLink = document.createElement("a");
    const fileName = item.name;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
//   })
},
saveUrl(){
  let locationId=this.locationid
    let locationNetworkId= this.locationnetworkid
    let locationNodeId= this.locationnodeid
    let customerId= this.customerid
    let contactId= this.contactid
    let deviceId= this.devceid
    let description = this.fileDescription
    let fileUrl= this.fileUrl
    let name =this.fileName
    let customerOrganisationId = this.customerOrganisationId
  Api()
      .post('/upload',{
        description: description,
        name: name,
        isActive: true,
        isDeleted: false,
        locationId: locationId,
        locationNetworkId: locationNetworkId,
        locationNodeId: locationNodeId,
        deviceId: deviceId,
        customerId: customerId,
        contactId: contactId,
        fileUrl: fileUrl,
        customerOrganisationId: customerOrganisationId
      }).then(response=>{
        this.$emit('documentChange')
        this.uploadFileModal=false
      })
},
saveEditedItem(){
  Api()
    .put('/upload/'+this.editedItem.id,{
      description: this.editedItem.description,
        name: this.editedItem.name,
        isActive: true,
        isDeleted: false,
        locationId: this.editedItem.locationId,
        locationNetworkId: this.editedItem.locationNetworkId,
        locationNodeId: this.editedItem.locationNodeId,
        deviceId: this.editedItem.deviceId,
        customerId: this.editedItem.customerId,
        contactId: this.editedItem.contactId,
        fileUrl: this.editedItem.fileUrl,
        customerOrganisationId: this.editedItem.customerOrganisationId
    })
    .then(response=>{
      this.$emit('documentChange')
        this.editFileModal=false
    })
},
formatDate(date) {
        return dateformat(date, "dd/mm/yyyy HH:mm");
    },
    async uploadFile(){
      var reader = new FileReader();
    await reader.readAsBinaryString(this.file);
    let file =''
    let locationId=this.locationid
    let locationNetworkId= this.locationnetworkid
    let locationNodeId= this.locationnodeid
    let customerId= this.customerid
    let contactId= this.contactid
    let deviceId= this.devceid
    let serviceAccountId= this.serviceaccountid
    let customerOrganisationId = this.customerOrganisationId


    let name =this.file.name
    let type=this.file.type
    let description = this.fileDescription
    let fileUrl= this.fileUrl
    reader.onload = await function() {
        file=btoa(reader.result)
        Api()
      .post('/upload',{
        description: description,
        name: name,
        type: type,
        isActive: true,
        isDeleted: false,
        locationId: locationId,
        locationNetworkId: locationNetworkId,
        locationNodeId: locationNodeId,
        deviceId: deviceId,
        customerId: customerId,
        contactId: contactId,
        serviceAccountId: serviceAccountId,
        base64: file,
        fileUrl: fileUrl,
        type: type,
        customerOrganisationId: customerOrganisationId
      })
      
    };
    this.$emit('documentChange')

    reader.onerror = function() {
        console.log('there are some problems');
    };
      
      this.uploadFileModal=false
    },
    addItem(){
      if(this.authCreate(this.$store.state.currentRoute)){ 
        this.uploadFileModal=true
      }
    },
    deleteFile(id){
      if(this.authDelete(this.$store.state.currentRoute)){ 
        confirm('Are you sure you would like to remove this file?')&&
        Api()
        .put('/upload/'+id,{
            iaActive: false,
            isDeleted: true
        }).then(response=>{
            this.$emit('documentChange')
        })
      }
    },
    editItem(item){
      if(this.authUpdate(this.$store.state.currentRoute)){ 
      this.editedItem = Object.assign({}, item);
      if(this.editedItem.base64!==null&&this.editedItem.base64!==''){
        this.editedItem.uploadType='File'
        this.file = Buffer.from(this.editedItem.base64, 'base64')
        // console.log(this.file)
      } else {
        this.editedItem.uploadType='URL'
      }
      this.editFileModal=true
    }}
}
}
</script>

<style>

</style>